import { useState } from 'react';
import { useParams } from 'react-router-dom';

type Error = {
  [key: string]: string | undefined;
};

type Input = {
  [key: string]: string;
};

type ValidateFields = string[];

const useForm = (initInput: Input, callback: () => void, validateFileds?: ValidateFields) => {
  const { url } = useParams();
  const [input, setInput] = useState(initInput);
  const [tags, setTags] = useState<string[]>([]);
  const [error, setError] = useState<Error>({});

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    clearValidation(name);

    setInput((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleAddTag = (field: string, tag: string) => {
    if (!tag.trim()) return;

    const isTagExist = tags.find((existingTag) => existingTag.toLowerCase() === tag);

    if (!isTagExist) {
      setTags((prev) => [...prev, tag]);
    }

    setInput((prev) => ({
      ...prev,
      [field]: '',
    }));
  };

  const handleDeleteTag = (idx: number) => {
    const updatedTags = tags.filter((_, index) => index !== idx);
    setTags(updatedTags);
  };

  const handlePressKey = (e: React.KeyboardEvent<HTMLDivElement>, field: string, tag: string) => {
    if (e.key === 'Enter') {
      handleAddTag(field, tag);
    }
  };

  const submit = (e: React.FormEvent<HTMLFormElement> | React.KeyboardEvent<HTMLDivElement>) => {
    e.preventDefault();

    if (!isFormValid()) return;

    if (url === 'chat') {
      setInput((prev) => ({
        ...prev,
        ['message']: '',
      }));
    }

    callback();
  };

  const handlePressEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      submit(e);
    }
  };

  const isFormValid = () => {
    let isFormValid = true;

    Object.entries(input).forEach(([key, value]) => {
      if (!validateFileds?.includes(key)) return;

      const userInput = typeof value === 'string' ? value : value + '';

      if (!userInput.trim()) {
        isFormValid = false;
        setError((prev) => ({ ...prev, [key]: 'Заполните поле' }));
      }

    });

    return isFormValid;
  };

  const clearValidation = (field: keyof Error) => {
    if (field) {
      setError((prevState) => ({
        ...prevState,
        [field]: undefined,
      }));
      return;
    }
    setError({});
  };

  const resetForm = () => {
    setInput(initInput);
    setTags([]);
    setError({});
  };

  return {
    input,
    error,
    handleChange,
    resetForm,
    submit,
    handlePressEnter,
    setError,
    handleAddTag,
    tags,
    handleDeleteTag,
    handlePressKey,
  };
};

export default useForm;
